export const FIELDS = {
  DEPARTURE: 'departure',
  DEPARTURE_OPTION: 'departureOption',
  DESTINATION: 'destination',
  DESTINATION_OPTION: 'destinationOption',
  DATE: 'date',
  ADULTS: 'adults',
  CHILDREN_AGES: 'childrenAges',
} as const;

export const FORM_NAME = 'busSearchForm';

export const LABELS = {
  [FIELDS.DEPARTURE]: 'Откуда',
  [FIELDS.DESTINATION]: 'Куда',
};

export const SEARCH_KEYS = {
  ADULTS: 'adults',
  CHILDREN: 'children',
  CHILDREN_AGES: 'children_ages',
  START_GEO_ID: 'start_geo_id',
  DEPARTURE_STATION_ID: 'departure_station_id',
  END_GEO_ID: 'end_geo_id',
  ARRIVAL_STATION_ID: 'arrival_station_id',
  DATE: 'date',
  RUN_NAME: 'run_name',
  SUPPLIER: 'supplier',
} as const;

export const SPA_FLAG = 's' as const;
